// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1ouky","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3gNTz"};